import { render } from "./UserKatmanlar.vue?vue&type=template&id=87e76c14&scoped=true"
import script from "./UserKatmanlar.vue?vue&type=script&lang=js"
export * from "./UserKatmanlar.vue?vue&type=script&lang=js"

import "./UserKatmanlar.vue?vue&type=style&index=0&id=87e76c14&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87e76c14"]])

export default __exports__